export default "__VITE_ASSET__DCvU0F26__"